module.exports = __webpack_public_path__ + "img/logo_bw.663267fa.png";